export const serviceProductCategories = [
  { id: 'civil', slug: 'civil-status' },
  { id: 'academic', slug: 'academic-translation' },
  { id: 'criminal', slug: 'police-clearance-certificate' },
  { id: 'driving', slug: 'driving-documents' },
  { id: 'financial', slug: 'financial-translation' },
  { id: 'business', slug: 'business-documents' },
  { id: 'legalMedical', slug: 'legal-medical' },
  { id: 'addons', slug: 'additional-services' },
];

export const featuredProductIds = [
  'birth', 'transcript', 'diploma', 'driving', 'criminal', 'marriage',
  'death', 'passport', 'judgment', 'attestation', 'invoice', 'apostilleDoc',
];

/** @type {Array<{ id: string, category: string, slug: string, price: number, orders?: number, rating?: number, featured?: boolean, orderId?: string, icon: string }>} */
export const serviceProducts = [
  // Featured / civil
  { id: 'birth', category: 'civil', slug: 'birth-certificate', price: 30, orders: 305, rating: 188, featured: true, orderId: 'birth', icon: 'Baby' },
  { id: 'marriage', category: 'civil', slug: 'marriage-certificate', price: 36, orders: 119, rating: 54, featured: true, orderId: 'marriage', icon: 'Heart' },
  { id: 'death', category: 'civil', slug: 'death-certificate', price: 25, priceMax: 55, orders: 50, rating: 18, featured: true, langPairCodes: ['ar-it', 'fr-it', 'it-ar', 'it-fr'], icon: 'FileText' },
  { id: 'passport', category: 'civil', slug: 'passport-translation', price: 28, orders: 32, rating: 3, featured: true, orderId: 'passport', icon: 'BookOpen' },
  { id: 'idcard', category: 'civil', slug: 'id-card', price: 37, orders: 12, rating: 2, orderId: 'idcard', icon: 'CreditCard' },
  { id: 'naturalization', category: 'civil', slug: 'naturalization-certificate', price: 37, orders: 8, rating: 4, icon: 'Award' },
  { id: 'celibacy', category: 'civil', slug: 'celibacy-certificate', price: 37, orders: 6, rating: 4, icon: 'UserCheck' },
  { id: 'residenceCard', category: 'civil', slug: 'residence-card', price: 37, orders: 4, rating: 1, icon: 'CreditCard' },
  { id: 'familyBook', category: 'civil', slug: 'family-book', price: 37, orders: 14, rating: 8, icon: 'Users' },
  { id: 'pacs', category: 'civil', slug: 'pacs-certificate', price: 30, orders: 3, rating: 1, icon: 'Heart' },
  { id: 'divorceCert', category: 'civil', slug: 'divorce-certificate', price: 40, orders: 10, rating: 7, icon: 'FileX' },
  { id: 'nameChange', category: 'civil', slug: 'name-change-certificate', price: 37, orders: 6, rating: 4, icon: 'PenLine' },
  { id: 'baptism', category: 'civil', slug: 'baptism-certificate', price: 37, icon: 'Sparkles' },
  { id: 'recognition', category: 'civil', slug: 'recognition-act', price: 37, orders: 4, rating: 2, icon: 'Baby' },
  { id: 'domicile', category: 'civil', slug: 'proof-of-address', price: 40, orders: 22, rating: 15, icon: 'Home' },

  // Academic
  { id: 'diploma', category: 'academic', slug: 'degree-diploma-certificate', price: 28, orders: 127, rating: 57, featured: true, orderId: 'diploma', icon: 'GraduationCap' },
  { id: 'transcript', category: 'academic', slug: 'transcript-translation', price: 28, orders: 129, rating: 45, featured: true, orderId: 'transcript', icon: 'FileText' },
  { id: 'transcriptUni', category: 'academic', slug: 'university-transcript', price: 35, orders: 68, rating: 54, icon: 'ScrollText' },
  { id: 'reportCard', category: 'academic', slug: 'school-report', price: 48, orders: 18, rating: 11, icon: 'ClipboardList' },
  { id: 'studyAttestation', category: 'academic', slug: 'study-attestation', price: 28, orders: 28, rating: 22, icon: 'School' },
  { id: 'enrollment', category: 'academic', slug: 'enrollment-certificate', price: 37, orders: 12, rating: 9, icon: 'BookOpen' },
  { id: 'schoolAttestation', category: 'academic', slug: 'school-attestation', price: 37, orders: 6, rating: 4, icon: 'BookMarked' },
  { id: 'internship', category: 'academic', slug: 'internship-certificate', price: 37, orders: 6, rating: 4, icon: 'Briefcase' },
  { id: 'recommendation', category: 'academic', slug: 'recommendation-letter', price: 40, orders: 8, rating: 3, icon: 'Mail' },
  { id: 'diplomaSupplement', category: 'academic', slug: 'diploma-supplement', price: 40, icon: 'FilePlus' },

  // Criminal
  { id: 'criminal', category: 'criminal', slug: 'criminal-record', price: 28, orders: 141, rating: 51, featured: true, orderId: 'criminal', icon: 'Shield' },

  // Driving
  { id: 'driving', category: 'driving', slug: 'driving-license', price: 28, orders: 129, rating: 115, featured: true, orderId: 'driving', icon: 'Car' },
  { id: 'insuranceRecord', category: 'driving', slug: 'insurance-record', price: 37, orders: 8, rating: 5, icon: 'ShieldCheck' },
  { id: 'registration', category: 'driving', slug: 'vehicle-registration', price: 45, orders: 16, rating: 12, icon: 'Car' },
  { id: 'insuranceAttestation', category: 'driving', slug: 'insurance-certificate', price: 40, orders: 12, rating: 9, icon: 'FileCheck' },
  { id: 'drivingRights', category: 'driving', slug: 'driving-rights', price: 37, orders: 20, rating: 16, icon: 'BadgeCheck' },
  { id: 'carSale', category: 'driving', slug: 'car-sale-contract', price: 48, orders: 4, rating: 2, icon: 'Handshake' },

  // Financial
  { id: 'invoice', category: 'financial', slug: 'invoice-translation', price: 30, orders: 33, rating: 16, featured: true, icon: 'Receipt' },
  { id: 'bankStatement', category: 'financial', slug: 'bank-statement', price: 42, orders: 14, rating: 11, icon: 'Landmark' },
  { id: 'taxNotice', category: 'financial', slug: 'tax-notice', price: 40, orders: 9, rating: 7, icon: 'Calculator' },
  { id: 'payslip', category: 'financial', slug: 'payslip', price: 40, orders: 8, rating: 5, icon: 'Wallet' },
  { id: 'employmentAttestation', category: 'financial', slug: 'employment-attestation', price: 30, orders: 14, rating: 11, icon: 'FileText' },
  { id: 'bankAttestation', category: 'financial', slug: 'bank-attestation', price: 40, orders: 14, rating: 11, icon: 'Building2' },

  // Business
  { id: 'kbis', category: 'business', slug: 'company-documents-attestation', price: 40, orders: 10, rating: 7, icon: 'Building' },
  { id: 'workContract', category: 'business', slug: 'work-contract', price: 40, orders: 3, rating: 1, orderId: 'contract', icon: 'FileSignature' },
  { id: 'workCertificate', category: 'business', slug: 'work-certificate', price: 40.8, orders: 12, rating: 10, icon: 'BadgeCheck' },
  { id: 'statutes', category: 'business', slug: 'company-statutes', price: 40, orders: 2, rating: 1, icon: 'ScrollText' },
  { id: 'saleAgreement', category: 'business', slug: 'sale-agreement', price: 48, orders: 2, rating: 1, icon: 'FileSignature' },
  { id: 'taxAttestation', category: 'business', slug: 'tax-attestation', price: 40, rating: 1, icon: 'FileSpreadsheet' },
  { id: 'sirene', category: 'business', slug: 'sirene-notice', price: 40, icon: 'Building2' },
  { id: 'commercialTranslation', category: 'business', slug: 'commercial-translation', price: 45, orders: 18, rating: 12, icon: 'Briefcase', image: '/images/services/business.jpg' },
  { id: 'onlineInterpreter', category: 'business', slug: 'online-meeting-interpreter', price: 120, orders: 24, rating: 17, icon: 'Users', unit: 'hour', image: '/images/earth-map.jpg' },
  { id: 'academicScientific', category: 'academic', slug: 'academic-scientific-translation', price: 45, orders: 21, rating: 14, icon: 'GraduationCap', image: '/images/services/academic.jpg' },
  { id: 'marketingAdvertising', category: 'business', slug: 'marketing-advertising-translation', price: 50, orders: 16, rating: 10, icon: 'Sparkles', image: '/images/services/company-documents-attestation.jpg' },
  { id: 'technicalWebsite', category: 'business', slug: 'technical-website-translation', price: 55, orders: 19, rating: 13, icon: 'FileText', image: '/images/services/company-statutes.jpg' },
  { id: 'tourismGuide', category: 'business', slug: 'tourism-guide-translation', price: 45, orders: 15, rating: 9, icon: 'BookOpen', image: '/images/earth-map.jpg' },

  // Legal & medical
  { id: 'judgment', category: 'legalMedical', slug: 'judgment-translation', price: 37, orders: 70, featured: true, orderId: 'judgment', icon: 'Gavel' },
  { id: 'attestation', category: 'legalMedical', slug: 'attestation-translation', price: 30, orders: 168, rating: 11, featured: true, icon: 'Stamp' },
  { id: 'adoptionJudgment', category: 'legalMedical', slug: 'adoption-judgment', price: 40, icon: 'Scale' },
  { id: 'divorceJudgment', category: 'legalMedical', slug: 'divorce-judgment', price: 40, orders: 4, rating: 2, icon: 'Gavel' },
  { id: 'will', category: 'legalMedical', slug: 'will-translation', price: 40, orders: 4, rating: 2, icon: 'ScrollText' },
  { id: 'medicalCert', category: 'legalMedical', slug: 'medical-certificate', price: 45, orders: 10, rating: 8, icon: 'Stethoscope' },
  { id: 'vaccination', category: 'legalMedical', slug: 'vaccination-record', price: 40.8, orders: 8, rating: 6, icon: 'Syringe' },
  { id: 'apostilleDoc', category: 'legalMedical', slug: 'apostille-services', price: 30, orders: 69, rating: 21, featured: true, orderId: 'apostilleDoc', icon: 'Stamp' },

  // Add-ons
  { id: 'extraCopy', category: 'addons', slug: 'extra-copy', price: 7.5, orders: 12, rating: 8, icon: 'Copy' },
  { id: 'reissue', category: 'addons', slug: 'reissue-translation', price: 20, orders: 7, rating: 5, icon: 'RefreshCw' },
  { id: 'signatureLegalization', category: 'addons', slug: 'certified-true-copy', price: 60, icon: 'PenTool' },
];

/** Category fallback images (real Unsplash photos) */
export const serviceCategoryImages = {
  civil: '/images/services/civil.jpg',
  academic: '/images/services/academic.jpg',
  criminal: '/images/services/criminal.jpg',
  driving: '/images/services/driving.jpg',
  financial: '/images/services/financial.jpg',
  business: '/images/services/business.jpg',
  legalMedical: '/images/services/legal-medical.jpg',
  addons: '/images/services/addons.jpg',
};

/** Real Tunisian document photos fallback by category */
const realCategoryImages = {
  civil: '/images/services/docs/doc-birth.jpg',
  academic: '/images/services/docs/doc-diploma.jpg',
  criminal: '/images/services/docs/doc-criminal-record.jpg',
  driving: '/images/services/_tn/cnam-recto.jpg',
  financial: '/images/services/facture-steg.jpg',
  business: '/images/services/business-contract.jpg',
  legalMedical: '/images/services/docs/doc-judgment.jpg',
  addons: '/images/services/docs/doc-apostille.jpg',
};

/**
 * Photos réelles de documents tunisiens (public/images/services/docs et _tn).
 * Prioritaires sur les visuels générés /images/services/{slug}.jpg.
 */
const realProductImages = {
  // État civil
  birth: '/images/services/docs/doc-birth.jpg',
  marriage: '/images/services/docs/doc-marriage.jpg',
  death: '/images/services/docs/doc-death.jpg',
  passport: '/images/services/_tn/pass-cover.jpg',
  idcard: '/images/services/_tn/cin-recto.jpg',
  residenceCard: '/images/services/_tn/cnam-verso.jpg',
  familyBook: '/images/services/_tn/livret.jpg',

  // Scolaire & universitaire
  diploma: '/images/services/docs/doc-diploma.jpg',
  transcript: '/images/services/docs/doc-transcript.jpg',

  // Casier judiciaire (B3)
  criminal: '/images/services/docs/doc-criminal-record.jpg',

  // Financier & fiscal
  invoice: '/images/services/facture-steg.jpg',
  bankStatement: '/images/services/bank-statement-real.jpg',
  payslip: '/images/services/payslip-real.jpg',
  employmentAttestation: '/images/services/attestation-real.jpg',

  // Entreprise & professionnel
  commercialTranslation: '/images/services/business-contract.jpg',
  onlineInterpreter: '/images/interpreting-remote.jpg',
  tourismGuide: '/images/earth-map.jpg',

  // Juridique & médical
  medicalCert: 'https://upload.wikimedia.org/wikipedia/commons/9/9c/Certificado_m%C3%A9dico.jpg',
  vaccination: 'https://upload.wikimedia.org/wikipedia/commons/6/6c/CDC_COVID-19_Vaccination_Record_Card.jpg',
  apostilleDoc: '/images/services/docs/doc-apostille.jpg',
  signatureLegalization: 'https://upload.wikimedia.org/wikipedia/commons/2/2c/Signature_notaire_espagnol.jpg',
};

export function getTunisiaProductImage(productId) {
  return realProductImages[productId] || null;
}

/** Per-service image: photo réelle tunisienne, puis image produit, puis visuel généré (slug), puis fallback catégorie */
export function getProductImage(product) {
  if (!product) return null;
  if (realProductImages[product.id]) return realProductImages[product.id];
  if (product.image) return product.image;
  if (product.slug) return `/images/services/${product.slug}.jpg`;
  if (realCategoryImages[product.category]) return realCategoryImages[product.category];
  return serviceCategoryImages[product.category] || serviceCategoryImages.civil;
}

export function getProductsByCategory(categoryId) {
  return serviceProducts.filter((p) => p.category === categoryId);
}

export function getProductBySlug(slug) {
  return serviceProducts.find((p) => p.slug === slug) || null;
}

export function getProductByDocId(docId) {
  return serviceProducts.find((p) => p.id === docId || p.orderId === docId) || null;
}

export function getServiceDetailPath(docId) {
  const product = getProductByDocId(docId);
  return product ? `/services/${product.slug}` : '/services';
}

export function getProductPriceRange(product) {
  const min = product.priceMin ?? product.price;
  const max = product.priceMax ?? Math.round(product.price * 1.6);
  return { min, max };
}

export function getProductLangPairCodes(product) {
  if (product.langPairCodes?.length) return product.langPairCodes;
  return ['fr-ar', 'ar-fr', 'fr-en', 'en-fr', 'fr-it', 'it-fr', 'ar-it', 'it-ar'];
}

export function getSimilarProducts(product, limit = 4) {
  return serviceProducts
    .filter((p) => p.category === product.category && p.id !== product.id)
    .sort((a, b) => (b.orders || 0) - (a.orders || 0))
    .slice(0, limit);
}

export function getFeaturedProducts() {
  return featuredProductIds
    .map((id) => serviceProducts.find((p) => p.id === id))
    .filter(Boolean);
}

export function filterAndSortProducts(products, { category, query, sort, getProductCopy }) {
  let list = [...products];

  if (category && category !== 'all') {
    list = list.filter((p) => p.category === category);
  }

  const normalizedQuery = query.trim().toLowerCase();
  if (normalizedQuery) {
    list = list.filter((p) => {
      const copy = getProductCopy(p.id);
      const haystack = `${copy?.title || ''} ${copy?.short || ''}`.toLowerCase();
      return haystack.includes(normalizedQuery);
    });
  }

  const byTitle = (a, b) => {
    const titleA = (getProductCopy(a.id)?.title || a.id).toLowerCase();
    const titleB = (getProductCopy(b.id)?.title || b.id).toLowerCase();
    return titleA.localeCompare(titleB);
  };

  switch (sort) {
    case 'priceAsc':
      list.sort((a, b) => a.price - b.price || byTitle(a, b));
      break;
    case 'priceDesc':
      list.sort((a, b) => b.price - a.price || byTitle(a, b));
      break;
    case 'name':
      list.sort(byTitle);
      break;
    case 'popular':
    default:
      list.sort((a, b) => (b.orders || 0) - (a.orders || 0) || byTitle(a, b));
      break;
  }

  return list;
}
